<template>
    <NuxtLayout name="main" :dark="true" :favorite="true">
        <div class="module-blat container">
            <!-- * 文件 -->
            <input ref="file" type="file" accept=".txt,.fa" @change="methods.upload" hidden />
            <!-- * 标题 -->
            <h1 class="module-header font-variable font-bold color-1">BLAT</h1>

            <!-- * 内容 -->
            <section class="module-content">
                <ui-form :data="data" :rules="rules" ref="form">
                    <div class="module-options">
                        <ui-form-item direction="column">
                            <h2 class="font-normal mb-[4px]">{{ $t("Species") }}</h2>
                            <ui-select v-model="data.species" width="100%" :candidates="options.species" @change="methods.species" />
                        </ui-form-item>

                        <ui-form-item direction="column">
                            <h2 class="font-normal mb-[4px]">{{ $t("Assembly") }}</h2>
                            <ui-select v-model="data.assembly" width="100%" :candidates="assembly" />
                        </ui-form-item>

                        <ui-form-item direction="column">
                            <h2 class="font-normal mb-[4px]">{{ $t("Sequence") }}</h2>
                            <ui-select v-model="data.mode" width="100%" :candidates="options.sequence" />
                        </ui-form-item>
                    </div>

                    <ui-form-item class="module-sequence" prop="sequence">
                        <ui-textarea class="module-input" v-model="data.sequence" name="sequence" :placeholder="$t('PleaseEnterSequence')" />
                    </ui-form-item>

                    <ui-button class="module-uploads" :class="css_button.upload" :width="112" @click="file?.click()">
                        {{ $t("UploadFile") }}
                    </ui-button>
                </ui-form>
            </section>

            <section class="module-controls">
                <ui-radio v-model="send_email" value="true">{{ $t("SendResultsbyEmail") }}</ui-radio>
                <ui-input class="module-input" v-model="data.email" v-show="send_email" :placeholder="$t('EmailPlaceholder')" />
            </section>

            <section class="module-footer">
                <ui-button class="module-submit" :class="css_button.append" size="middle" :width="136" @click="methods.submit">
                    {{ $t("Submit") }}
                </ui-button>

                <div class="module-introduce" v-html="$t('BLATIntroduction')"></div>
            </section>
        </div>
    </NuxtLayout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiForm, UiRadio, UiInput, UiSelect, UiButton, UiTextarea, UiFormItem } from "various-ui";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css_button from "@/assets/style/src/button.module.less";

//* 组合函数
const { vars, refs, data, nodes, rules, methods, options } = useComposable();
const { form, file } = nodes;
const { send_email, assembly } = refs;
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
